var _g, _rect, _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaytm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 306,
    viewBox: "0 0 392 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_454_1507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 286,
    height: 200,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 52,
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "#6C63FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 59.5,
    r: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.909 127.978C256.635 124.335 253.162 121.719 249.084 121.719H248.998C246.347 121.719 243.957 122.822 242.256 124.594C240.552 122.822 238.162 121.719 235.514 121.719H235.428C233.097 121.719 230.967 122.572 229.331 123.985V123.266C229.275 122.551 228.686 121.989 227.959 121.989H221.703C220.937 121.989 220.32 122.607 220.32 123.375V157.351C220.32 158.119 220.938 158.737 221.703 158.737H227.959C228.657 158.737 229.231 158.216 229.322 157.542L229.319 133.151C229.319 133.066 229.322 132.986 229.331 132.907C229.431 131.818 230.229 130.923 231.489 130.811H232.642C233.169 130.858 233.613 131.044 233.963 131.323C234.508 131.756 234.811 132.421 234.811 133.151L234.834 157.422C234.834 158.19 235.455 158.811 236.217 158.811H242.474C243.212 158.811 243.813 158.222 243.849 157.489L243.846 133.119C243.843 132.318 244.214 131.594 244.864 131.165C245.184 130.959 245.57 130.821 246.014 130.779H247.168C248.522 130.897 249.34 131.924 249.337 133.119L249.361 157.357C249.361 158.125 249.982 158.743 250.744 158.743H257C257.762 158.743 258.383 158.125 258.383 157.357V131.289C258.383 129.511 258.183 128.755 257.909 127.978V127.978ZM215.553 122.078H211.974V116.262C211.974 115.565 211.409 115 210.712 115C210.629 115 210.55 115.012 210.473 115.026C206.506 116.115 207.301 121.61 200.059 122.078H199.355C199.249 122.078 199.149 122.092 199.052 122.113H199.046L199.052 122.116C198.433 122.254 197.969 122.801 197.969 123.461V129.718C197.969 130.48 198.59 131.101 199.354 131.101H203.13L203.125 157.632C203.125 158.388 203.737 159 204.493 159H210.679C211.432 159 212.044 158.388 212.044 157.632L212.047 131.101H215.552C216.314 131.101 216.935 130.48 216.935 129.718V123.461C216.937 122.699 216.315 122.078 215.553 122.078V122.078Z",
    fill: "#54C1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.042 122.077H186.785C186.023 122.077 185.405 122.698 185.405 123.46V136.397C185.391 137.198 184.743 137.84 183.94 137.84H181.321C180.509 137.84 179.852 137.186 179.852 136.374L179.829 123.46C179.829 122.698 179.208 122.077 178.446 122.077H172.188C171.423 122.077 170.805 122.698 170.805 123.46V137.64C170.805 143.025 174.646 146.866 180.034 146.866C180.034 146.866 184.078 146.866 184.201 146.889C184.931 146.972 185.499 147.584 185.499 148.337C185.499 149.082 184.943 149.691 184.222 149.782C184.186 149.788 184.154 149.797 184.115 149.803L174.966 149.836C174.2 149.836 173.583 150.457 173.583 151.219V157.472C173.583 158.238 174.201 158.855 174.966 158.855H185.195C190.586 158.855 194.424 155.018 194.424 149.629V123.461C194.425 122.698 193.807 122.077 193.042 122.077V122.077ZM133.032 122.076H119.357C118.606 122.076 118 122.685 118 123.433V129.563C118 129.575 118.003 129.587 118.003 129.598C118.003 129.628 118 129.657 118 129.684V157.429C118 158.183 118.565 158.798 119.266 158.815H125.64C126.402 158.815 127.023 158.197 127.023 157.432L127.047 147.924H133.033C138.042 147.924 141.532 144.448 141.532 139.419V130.593C141.532 125.563 138.041 122.076 133.032 122.076V122.076ZM132.482 137.403C132.482 138.212 131.825 138.871 131.016 138.871L127.046 138.874V131.137H131.016C131.825 131.137 132.482 131.79 132.482 132.603V137.403ZM157.447 122.112H148.766C147.998 122.112 147.377 122.694 147.377 123.409V125.843C147.377 125.858 147.379 125.876 147.379 125.89C147.379 125.908 147.377 125.925 147.377 125.943V129.277C147.377 130.034 148.036 130.651 148.848 130.651H157.115C157.768 130.754 158.286 131.231 158.36 131.975V132.782C158.286 133.491 157.774 134.009 157.15 134.068H153.056C147.612 134.068 143.733 137.685 143.733 142.764V150.039C143.733 155.089 147.068 158.682 152.474 158.682H163.819C165.855 158.682 167.506 157.14 167.506 155.241V131.503C167.506 125.746 164.54 122.112 157.447 122.112V122.112ZM158.442 149.207C158.442 149.287 158.43 149.363 158.419 149.437C158.404 149.506 158.384 149.574 158.36 149.64C158.165 150.188 157.618 150.585 156.968 150.585H154.363C153.551 150.585 152.889 149.966 152.889 149.207V148.027C152.889 148.012 152.886 147.998 152.886 147.982L152.889 144.842V143.86L152.891 143.851C152.894 143.094 153.551 142.482 154.363 142.482H156.967C157.782 142.482 158.442 143.097 158.442 143.86V149.207H158.442Z",
    fill: "#233266"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_454_1507",
    x: 0,
    y: 0,
    width: 392,
    height: 306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_454_1507"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_454_1507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_454_1507",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaytm);
export default __webpack_public_path__ + "static/media/paytm.6acc0dd8c54502cca3b95ae06488563b.svg";
export { ForwardRef as ReactComponent };